// TicketMessageDialog.tsx
import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Stack,
  Typography,
  Box,
  CircularProgress
} from "@mui/material";
import rootStores from "../../stores";

export type TicketMessageAction = "send" | "cancel";
export type TicketMessageChannel = "whatsapp" | "sms";

const concertStore = rootStores.ConcertStore;

type Props = {
  open: boolean;
  action: TicketMessageAction;
  ticketRow: any | null;
  isEditing: boolean;
  onClose: () => void;
  onChoose: (channel: TicketMessageChannel) => void;
  phoneError?: string;
  bulkMode?: boolean;
};

export default function TicketMessageDialog({
  open,
  action,
  ticketRow,
  isEditing,
  onClose,
  onChoose,
  phoneError,
  bulkMode
}: Props) {
  const title = action === "send" ? "Send ticket" : "Send cancellation";

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>{title}</DialogTitle>

      {concertStore.isLoading ? (
          <Box
            sx={{
              minHeight: 200,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
            }}
          >
            <CircularProgress />
          </Box>
        ) : (
          <>
          <DialogContent>
          <Typography variant="body2" sx={{ mb: 2 }}>
            Choose channel:
          </Typography>
  
          {phoneError && (
            <Typography variant="body2" sx={{ color: "error.main", mb: 2 }}>
              {phoneError}
            </Typography>
          )}
  
          <Stack direction="column" gap={1}>
            <Button
              variant="contained"
              onClick={() => onChoose("whatsapp")}
              disabled={isEditing || (!ticketRow && !bulkMode)}
            >
              WhatsApp
            </Button>
  
            <Button
              variant="outlined"
              onClick={() => onChoose("sms")}
              disabled={isEditing || (!ticketRow && !bulkMode)}
            >
              SMS
            </Button>
          </Stack>
        </DialogContent>
  
        <DialogActions>
          <Button onClick={onClose} variant="text">
            Cancel
          </Button>
        </DialogActions>
        </>
        )}

    </Dialog>
  );
}